import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@emotion/css';

const sectionHeader = (params) => css`
  margin-bottom: 15px;
  text-align: left;
  width: fit-content;
  text-overflow: ellipsis;
  overflow: hidden; 
  white-space: nowrap;
  color: ${params?.titleColor};
  font-size: ${params?.titleFontSize};
  font-weight: ${params?.titleFontWeight}
`;

const FilterTitle = ({ label, themeConfig }) => (
  <div className={cx(sectionHeader(themeConfig), themeConfig.titleFontType)}>
    {`${label}`}
  </div>
);

FilterTitle.propTypes = {
  label: PropTypes.string,
  themeConfig: PropTypes.object,
};

export default FilterTitle;
